import script from "./FeedbackModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackModal.vue?vue&type=style&index=0&id=08bd5fca&scoped=true&lang=css"
import "./FeedbackModal.vue?vue&type=style&index=1&id=08bd5fca&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bd5fca"]])

export default __exports__